<img [src]="logoUrl" alt="Logo">
